export type FollowState = {
  isFollowing: boolean
  followersCount: number
}

export function computeFollowOptimistic(state: FollowState): FollowState {
  const delta = state.isFollowing ? -1 : 1
  return {
    isFollowing: !state.isFollowing,
    followersCount: Math.max(0, state.followersCount + delta),
  }
}
